import { BiSortAlt2 } from 'react-icons/bi';
import { Button } from '@/components/ui/button';
const KeypadHeader = ({
  token,
  usdAmount,
  isSwitched,
  setIsSwitched,
  tokenAmount
}) => {
  const calculatedAmount = isSwitched ? tokenAmount : usdAmount;
  const displayCurrency = isSwitched ? token?.contract_ticker_symbol : 'USD';
  function centerAmount(calculatedAmount) {
    const length = calculatedAmount?.toString().length || 0;
    if (length === 2) {
      return 'text-[60px]';
    }
    if (length >= 10) {
      return 'text-[20px]';
    }
    if (length >= 9) {
      return 'text-[24px]';
    }
    if (length >= 8) {
      return 'text-[28px]';
    }
    if (length >= 7) {
      return 'text-[32px]';
    }
    if (length >= 6) {
      return 'text-[38px]';
    }
    if (length >= 5) {
      return 'text-[42px]';
    }
    if (length >= 4) {
      return 'text-[42px]';
    }
    if (length >= 3) {
      return 'text-[42px]';
    }
    return 'text-[60px]'; // Default for no value or single-digit input
  }
  return <>
      <div className='w-full'>
        <div className='m-auto text-5xl focus:outline-none break-all placeholder:text-genius-primary placeholder:opacity-50 text-primary bg-transparent ta-c'>
          <div className='relative h-36'>
            <div className={`ml-4 absolute flex gap-4 w-full justify-center items-center top-[0px] transform -translate-y-1/2 transition-all ${centerAmount(calculatedAmount)}`}>
              <p className='ta-r flex'>
                {!isSwitched ? usdAmount : tokenAmount}
                <span className='text-genius-cream/70 ml-2'>{displayCurrency}</span>
              </p>
              <Button variant='ghost' type='button' size='icon' className='bg-genius-blue rounded-full w-[25px] h-[25px] md:hover:bg-genius-blue' onClick={() => {
              setIsSwitched(!isSwitched);
            }} data-sentry-element="Button" data-sentry-source-file="KeypadHeader.tsx">
                <BiSortAlt2 className='text-primary w-[10px] h-[10px]' data-sentry-element="BiSortAlt2" data-sentry-source-file="KeypadHeader.tsx" />
              </Button>
            </div>

            <div className='absolute top-14 w-full grid justify-items-center'>
              <div className='flex flex-nowrap justify-center items-center mt-4 gap-1 text-sm'>
                {!isSwitched ? <>
                    <p className='opacity-40'>{tokenAmount}</p>
                    <p className='opacity-40'>Of</p>
                    <p>{token?.contract_ticker_symbol}</p>
                  </> : <p className='opacity-40'>{usdAmount} USD</p>}
              </div>
              <div className='text-genius-cream/20 text-xs flex gap-1'>
                <p>Max Balance:</p>
                <p className='text-genius-cream/40'>{token.formatted_balance?.toFixed(2)}</p>
                <p>(${token.usd_value?.toFixed(2)})</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>;
};
export default KeypadHeader;